import { render, staticRenderFns } from "./TagUpsertComponent.vue?vue&type=template&id=26141d98&"
import script from "./TagUpsertComponent.vue?vue&type=script&lang=ts&"
export * from "./TagUpsertComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports